import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";
import {Router} from "@angular/router";

@Component({
  selector: 'app-connect-digital-business-card',
  templateUrl: './connect-digital-business-card.component.html',
  styleUrls: ['./connect-digital-business-card.component.scss', './connect-digital-business-card-media.component.scss']
})
export class ConnectDigitalBusinessCardComponent {

  currentLang: string = '';

  constructor(private router: Router,
              public translate: TranslateService) {
    this.translate.setDefaultLang(Language.HY);
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  createCard() {
    this.router.navigate(['/prices']);
  }

  protected readonly Language = Language;
}
